export default "/images/_Industrien.webp?0020c07f4be3a16a4e8abf3193af48d9";